<script>
import { page } from '$app/stores';
import {storyblokEditable, StoryblokComponent} from "@storyblok/svelte";
import { Turnstile } from 'sveltekit-turnstile';
import { Input, Textarea, Select, Fileupload, Dropdown, DropdownItem, Label } from 'flowbite-svelte';
import { PUBLIC_TURNSTILE_SITE_KEY } from '$env/static/public'
import closeIcon from '$lib/images/close-black.svg';
import Formulier from './nestable-blocks/Formulier.svelte';

export let algemeen;

let popupIsOpen = false;
let dropdownOpen = false;
let selectedValue = [];
let scrollDepth = 0;

function openPopup() {
    popupIsOpen = !popupIsOpen
}
function openDropdown() {
    dropdownOpen = !dropdownOpen
}
</script>

<svelte:window bind:scrollY={scrollDepth} />
<div class="sticky-form-holder {popupIsOpen ? 'open' : ''} {scrollDepth > 300 ? 'show':''}">
    <div class="popup-label" on:click={openPopup}>
        <span>Maak een afspraak</span>
    </div>

    <div class="popup {popupIsOpen ? 'open' : ''}">
        <div class="popup-inner">
            <img src={closeIcon} class="close-icon" alt="" quality="100" on:click={openPopup} />
            
            <div id="formulier" class="formulier-holder">
                <Formulier blok={algemeen.formulier[0]} />
            </div>
        </div>
    </div>
</div>

<div class="popup-backdrop {popupIsOpen ? 'open' : ''}"></div>

<style lang="postcss">
    .title-holder {
        margin-bottom: 30px;

        .h2 {
            color: var(--blue);
        }
    }

    .popup-label {
        background-color: var(--red);
        position: fixed;
        right: 20px;
        top: 50%;
        transform: rotate(90deg) translateX(50%) translateY(-50%);
        transform-origin: top right;
        font-family: var(--body-font);
        font-size: 16px;
        padding: 15px 20px 8px 20px;
        box-shadow: 2px 0 5px 0 rgba(0,0,0, 0.2);
        cursor: pointer;
        z-index: 101;
        color: var(--white);
    }

    .popup {
        position: fixed;
        width: 100%;
        max-width: 900px;
        transition: all .4s;
        transform: scale(0);
        transform-origin: right;
        opacity: 0;
        visibility: hidden;
        right: 50%;
        top: 50%;
        transform: translate(50%, -50%);

        &.open {
            transform: scale(1) translate(50%, -50%);
            opacity: 1;
            visibility: visible;
            z-index: 101;
        }

        .popup-inner {
            background-color: var(--beige);
            max-height: 85vh;
            height: 100%;
            overflow-x: hidden;
            box-sizing: border-box;
        }
    }

    .close-icon {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
    }

    .input-holder {
        margin-bottom: 10px;
    }

    .popup-backdrop {
        background-color: #000;
        opacity: 0;
        visibility: hidden;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        transition: all .4s;
        z-index: 100;

        &.open {
            opacity: 0.5;
            visibility: visible;
        }
    }

    :global(.popup .popup-inner .form-container) {
        padding: 0;
    }

    :global(.popup .popup-inner .component) {
        margin-bottom: 0;
    }   

    .selector {
        position: relative;
        cursor: pointer;

        &.open {
            z-index: 2;
        }
        &:hover {
            z-index: 3;
        }
    }

    .selector .current {
        font-family: var(--body-font);
        width: 100%;
        padding: 15px 25px;
        box-sizing: border-box;
        border: 1px solid var(--white);
        background-color: var(--white);
        box-shadow: none !important;
        border-radius: 8px;
        font-weight: 400;
        font-size: 17px;
        outline: none !important;
        line-height: 29px;
        display: block;
        position: relative;

        &::after {
            content: '';
            background-image: url(/src/lib/images/arrow-small.svg);
            background-size: cover;
            position: absolute;
            right: 20px;
            top: 25px;
            width: 12px;
            height: 7px;
            transition: all .4s;
        }
    }

    .selector.open .current::after {
        transform: rotate(180deg);
    }

    .selector ul {
        position: relative;
        width: 100%;
        top: 100%;
        border: 1px solid var(--beige);
        background-color: var(---beige);
        box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2);
        visibility: hidden;
        opacity: 0;
        transform: scale(0.8);
        transition: all 300ms;
        background-color: var(--white);
        padding: 0 10px;
        border-radius: 8px;
        max-height: 0;
    }

    .selector.open ul {
        opacity: 1;
        visibility: visible;
        transition: all 300ms;
        transform: scale(1);
        padding: 10px;
        max-height: 700px;    
    }

    .selector ul li {
        padding: 10px 20px;
        transition: all 300ms;
        border-radius: 5px;

    &:hover,
        &.selected {
            background-color: var(--beige);
        }
    }
    @media only screen and (max-width: 1023px) {
        .popup .popup-inner {
            padding: 20px 0px;
        }
    }

    @media only screen and (max-width: 767px) {
        .sticky-form-holder {
            padding-right: 75px;
            transition: all .4s;
        }

        .popup {
            max-width: calc(100% - 40px);
        }

        .popup .title-holder .calendar-icon {
            max-width: 20px;
        }

        :global(header.menu-open ~ .sticky-form-holder) {
            opacity: 0;
            visibility: hidden;
        }

    }
</style>